import { render, staticRenderFns } from "./StepsInfo.vue?vue&type=template&id=54386ed8&"
import script from "./StepsInfo.vue?vue&type=script&lang=js&"
export * from "./StepsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54386ed8')) {
      api.createRecord('54386ed8', component.options)
    } else {
      api.reload('54386ed8', component.options)
    }
    module.hot.accept("./StepsInfo.vue?vue&type=template&id=54386ed8&", function () {
      api.rerender('54386ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/StepsInfo.vue"
export default component.exports